import { render, staticRenderFns } from "./BaseStorableItem.vue?vue&type=template&id=46b8fb35&scoped=true&"
import script from "./BaseStorableItem.vue?vue&type=script&lang=ts&"
export * from "./BaseStorableItem.vue?vue&type=script&lang=ts&"
import style0 from "./BaseStorableItem.vue?vue&type=style&index=0&id=46b8fb35&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b8fb35",
  null
  
)

export default component.exports